module.exports = __webpack_public_path__ + "img/selected6-min.a25618c9.png";